module.exports = __webpack_public_path__ + "static/media/10.c524f715.mp3";